import React from 'react'
import { Link } from 'react-router-dom'
import Index from '../sections/Index'
import About from '../sections/About'
import Services from '../sections/Services'
import Portfolio from '../sections/Portfolio'
import Faq from '../sections/Faq'
import Contact from '../sections/Contact'
import '@fortawesome/fontawesome-free/css/all.min.css'
import './Main.scss'

export default function Main() {
  return (
    <>
      <Index />
      <main id="main">
        <About />
        <Services />
        <Portfolio />
        <Faq />
        <Contact />
      </main>
    </>
  )
}
